import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
import formatDate from 'date-fns/format'
import { requestSalesChannelsList } from 'requests/sales-channels'
import useSimpleList from 'hooks/useSimpleList'
import { EMPTY_ORDER } from 'constants/objects/order'
import { API_DATE_FORMAT, DEFAULT_HOUR_FORMAT } from 'constants/date'
import { Form as FormComponent } from 'components/Form'
import { SelectCustomer } from 'components/SelectCustomer'
import { RadioGroup } from 'ui-components/RadioGroup'
import { Skeleton } from 'ui-components/Skeleton'
import { ApiErrors } from 'ui-components/ApiErrors'
import {
  TitleForm,
  InputDate,
  InputHour,
} from 'components/Form/components'
import { DateTimeContainer, SelectContainer } from './styles'

export default function OrderForm(props) {
  const {
    onCancel,
    saving,
    order,
    responseError,
    onSave,
  } = props

  const [attributes, setAttributes] = useState({})
  const [channelsOptions, setChannelsOptions] = useState([])

  const [channels, channelsState] = useSimpleList({
    requestList: requestSalesChannelsList,
  })

  useEffect(() => {
    const options = channels.map((item) => ({
      id: item.id,
      name: item.attributes.name,
    }))

    setChannelsOptions(options)
  }, [channels])

  useEffect(() => {
    let channelId = order.attributes.sales_channel_id
    if (channels.length && !channelId) {
      channelId = channels[0].id
    }

    setAttributes({
      ...order.attributes,
      sales_channel_id: channelId,
    })
  }, [order, channels])

  const updateAttr = (name, value) => {
    const attr = cloneDeep(attributes)
    set(attr, name, value)
    setAttributes(attr)
  }

  const handleSave = () => {
    const date = formatDate(attributes.date, API_DATE_FORMAT)
    const hour = formatDate(attributes.hour, DEFAULT_HOUR_FORMAT)

    const params = {
      ...attributes,
      date,
      hour,
    }

    onSave(params)
  }

  const handleSelectCustomer = (customer) => {
    setAttributes({
      ...attributes,
      ...customer,
    })
  }

  const handleDateTimeChange = ({ name, datetime }) => {
    updateAttr(name, datetime)
  }

  const handleChannelChange = (evt) => {
    const { value, name } = evt.target
    updateAttr(name, value)
  }
  const renderSalesChannels = () => {
    if (channelsState.loading) return (<Skeleton height={60} />)

    return (
      <RadioGroup
        options={channelsOptions}
        onChange={handleChannelChange}
        name="sales_channel_id"
        label="Canal de venda"
        value={attributes.sales_channel_id}
        row
      />
    )
  }

  return (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Novo Pedido</TitleForm>

      <ApiErrors responseError={responseError} />

      <div>
        {renderSalesChannels()}
      </div>

      <DateTimeContainer>
        <InputDate
          id="date"
          label="Data"
          name="date"
          value={attributes.date}
          onChange={handleDateTimeChange}
          InputLabelProps={{
            shrink: true,
          }}
        />

        <InputHour
          id="hora"
          label="Hora"
          name="hour"
          value={attributes.hour}
          onChange={handleDateTimeChange}
        />
      </DateTimeContainer>

      <SelectContainer>
        <SelectCustomer onSelectCustomer={handleSelectCustomer} />
      </SelectContainer>
    </FormComponent>
  )
}

OrderForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  order: PropTypes.objectOf(PropTypes.any),
  responseError: PropTypes.objectOf(PropTypes.any),
  onSave: PropTypes.func.isRequired,
}

OrderForm.defaultProps = {
  saving: false,
  order: EMPTY_ORDER,
  responseError: {},
}
